import React from 'react';
import styled from 'styled-components';
import { Icon } from '../../facades';
import * as StepperTypes from '.';

export const IndicatorHeader = ({ steps, activeStep }: StepperTypes.Header) => (
    <div className="indicatorHeader d-flex flex-row align-items-start">
        {steps.map((step, index) => {
            return (
                <StepWrapper key={`step-${index}`}>
                    {step.completed === true || activeStep === steps.length - 1
                        ? <span className={index !== 0 ? 'with-dash' : undefined}><IconWrapper>
                            <Icon style={{fontSize: 32, margin: -3}} icon='check-circle' lib='fas' className="position-absolute"/>
                            </IconWrapper></span>
                        : <StepperButton className={`${index !== 0 ? 'with-dash' : ''} button_${index} btn btn-primary p-0 rounded-circle d-inline-flex flex-column justify-content-center align-items-center`} disabled={activeStep !== index}>{index + 1}</StepperButton>
                    }
                    <span className="ml-2 text-muted body-md stepName">{step.name}</span>
                </StepWrapper>
            );
        })}
    </div>
);

export default IndicatorHeader;

const IconWrapper = styled.span.attrs(() => ({
    className: 'bg-white text-success align-middle rounded-circle d-inline-block',
}))`
    width: 32px;
    height: 32px;
`;

const StepWrapper = styled.div`
    & .with-dash {
        display: inline-block;
        position: relative;
        margin-left: 3rem;
        &:before {
            content: "";
            position: absolute;
            border-bottom: 1px solid rgb(163, 163, 163);
            top: 0.875rem;
            right: 2.75rem;
            width: 1.5rem;
        }
    }
    .stepName {
        margin-top: .5rem;
    }
`

const StepperButton = styled.button`
    height: 2rem;
    width: 2rem;
    &:disabled {
        background: #d8d8d8;
        color: #212121;
    }
`;
